import { StyledError } from 'pages/InfoRequestPage.styles'
import Icon from './Icon'

const ErrorMessage = ({ error }: { error: string }): JSX.Element => {
  return (
    <StyledError>
      {error && Icon('error')}
      <span>{error}</span>
    </StyledError>
  )
}

export default ErrorMessage
